// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".product-card[data-v-7b27cc49]{display:flex;flex-wrap:wrap;justify-content:center}", "",{"version":3,"sources":["/Users/niwashouta/projects/kgi_sfa/app/javascript/erp_src/view/matter/components/MatterMoneyForm.vue"],"names":[],"mappings":"AAGA,+BACC,YAAA,CACA,cAAA,CACA,sBAAA","file":"MatterMoneyForm.vue","sourcesContent":["\n@import \"../../../stylesheet/variable.scss\";\n\n.product-card {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tjustify-content: center;\n}\n"]}]);
// Exports
module.exports = exports;
